import Teams from './Teams';
import Appointees from './Appointees';
import CommandButtons from './CommandButtons/CommandButtons.container';

const calculate = (rowData) => {
    return `${rowData['description']} (${rowData['type']})`;
};

const schema = [
    { field: 'year', label: 'Year', forDisplay: false},
    { field: 'type', label: 'Type', forDisplay: false},
    { field: 'description', label: 'Description', forDisplay: false},
    { field: 'description type', label: 'Type Description (Type)', calculate, className: 'th-td-15' },
    { field: 'template', label: 'Template', className: 'th-td-20'},
    { field: 'teams', label: 'Teams', component: Teams, className: 'th-td-25'},
    { field: 'appointees', label: 'Appointees', component: Appointees, className: 'th-td-20' },
    { field: 'checked', label: 'Actions', component: CommandButtons, className: 'th-td-20', align: 'center'}
];

const keyField = 'key';

export default schema;

export {keyField};